/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { Observable, Subscription } from 'rxjs';

import { map, startWith } from 'rxjs/operators';
import { ApiService } from '@app/@core/services';
import { PageService } from "@auth/services";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MessageService } from '@app/@shared/components/message/message.service';

@Component({
  selector: 'associates-introducer-gifts-dialog',
  templateUrl: './introducer-gifts-dialog.component.html',
  styleUrls: ['./introducer-gifts-dialog.component.scss'],
})
export class AssociatesIntroducerGiftsDialogComponent implements OnInit {
  constructor (
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private pageService: PageService,
    private _notification: MessageService,
    public mbsRef: MatBottomSheetRef) {
  }

  ngOnInit() {
    this.getGifts();
  }

  private giftSub: Subscription;
  dataLoaded = false;
  processing = false;
  authForm = this.formBuilder.group({
    gifts_list: this.formBuilder.array([])
  });

  get gifts_list(): FormArray {
    return <FormArray>this.authForm.controls.gifts_list;
  }

  resetForm(ref = null) {
    if (!ref) {
      this.authForm.reset();
    } else {
      const form_field = this.authForm.get(ref);
      if (!form_field.validator) return form_field.reset();

      const validator = form_field.validator({} as AbstractControl);
      if (validator && validator.required) form_field.setValue('');
      else form_field.reset();
    }
  }

  getGifts() {
    this.giftSub = this.apiService.get('associates/clients/' + this.data.client_uuid + '/introducer-scheme/' + this.data.item.uuid + '/gifts')
      .subscribe(res => {
        if (res.error === false) {
          let gifts = res.data;
          gifts.forEach(gift => {
            let row = this.formBuilder.group({
              name: [gift.name, Validators.required],
              serial: [gift.serial, Validators.required],
              value: [gift.value, Validators.required],
            });

            this.gifts_list.push(row);
          });
          this.addRow();
        }
        this.dataLoaded = true;
      });
  }

  giftsCount() {
    let count = 0;
    this.gifts_list.controls.forEach((ctrl) => {
      if (ctrl.valid) count++;
    });
    return count;
  }

  submitForm() {
    this.processing = true;
    let gifts_array = [];
    this.gifts_list.controls.forEach((ctrl) => {
      if (ctrl.valid) gifts_array.push(ctrl.value);
    });
    let url = "associates/clients/" + this.data.client_uuid + "/introducer-scheme/" + this.data.item.uuid + "/gifts";
    this.apiService.post(url, {'gifts': JSON.stringify(gifts_array)}).subscribe((res) => {
      // console.log("POST clients", res);
      if (res.error === false) {
        // Client Created
        this._notification.create('success', 'LFA - Introducer Scheme ' + this.data.item.year + ' updated successfully.', { Position: 'top', Style: 'bar', Duration: 2000 });
        this.mbsRef.dismiss();
        this.pageService.triggerParentRefresh(true);
      }

      this.processing = false;
    });
  }

  addRow() {
    if (this.authForm.valid) this.gifts_list.push(this.row_default());
  }

  removeRow(rowIndex) {
    this.gifts_list.removeAt(rowIndex);
  }

  row_default() {
    return this.formBuilder.group({
      name: ['', Validators.required],
      serial: ['', Validators.required],
      value: [0.00, Validators.required],
    });
  }
}